const colors = {
  cloudBlue: '#2E7CF6',
  darkCloudBlue: '#0058EF',
  darkRoyalBlue: '#0033AA',
};

export default colors;
